"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const colorAppBar = "#FFFFFF";
const colorOnAppBar = "#4EAF72";
const colorPrimary = "#4EAF72";
const colorPrimaryDarker = "#3b8557";
const colorPrimaryLighter = "#dbefe3";
const colorOnPrimary = "#FFFFFF";
const colorSecondary = "#FFB694";
const colorOnSecondary = "#000000";
const colorTiles = ["#FFB694", "#FFB694", "#FFB694"];
exports.default = {
    colorAppBar,
    colorOnAppBar,
    colorPrimary,
    colorPrimaryDarker,
    colorPrimaryLighter,
    colorOnPrimary,
    colorSecondary,
    colorOnSecondary,
    colorTiles,
};
